module.exports = __webpack_public_path__ + "images/emoji/man.f5a905efb51abb8ada21.png";